import { render, staticRenderFns } from "./buildLogin copy.vue?vue&type=template&id=515a4030&scoped=true"
import script from "./buildLogin copy.vue?vue&type=script&lang=js"
export * from "./buildLogin copy.vue?vue&type=script&lang=js"
import style0 from "./buildLogin copy.vue?vue&type=style&index=0&id=515a4030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a4030",
  null
  
)

export default component.exports